import { ReportColumn } from '../shared/types';
import { formatMoney } from '@/utils/currency';

export interface PurchaseSummaryRow {
  status: string;
  purchase_bills: number;
  gross_purchase: number;
  paid: number;
  outstanding: number;
  returns: number;
}

export const purchaseSummaryColumns: ReportColumn<PurchaseSummaryRow>[] = [
  { id: 'status', header: 'Status', accessorKey: 'status' },
  { id: 'purchase_bills', header: 'Purchase Bills', accessorKey: 'purchase_bills', align: 'right' },
  {
    id: 'gross_purchase',
    header: 'Gross Purchase',
    align: 'right',
    cell: (r) => `${formatMoney(r.gross_purchase)}`,
    exportValue: (r) => r.gross_purchase,
  },
  {
    id: 'paid',
    header: 'Paid',
    align: 'right',
    cell: (r) => `${formatMoney(r.paid)}`,
    exportValue: (r) => r.paid,
  },
  {
    id: 'outstanding',
    header: 'Outstanding',
    align: 'right',
    cell: (r) => `${formatMoney(r.outstanding)}`,
    exportValue: (r) => r.outstanding,
  },
  {
    id: 'returns',
    header: 'Returns',
    align: 'right',
    cell: (r) => `${formatMoney(r.returns)}`,
    exportValue: (r) => r.returns,
  },
];
